import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class AntiFallPpeTypeDto extends BaseEntityDto {
  name: string;
}
